var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container product-section-main"},[_c('div',{staticClass:"row my-4 product-list"},_vm._l((_vm.productParent),function(product,i){return _c('div',{key:i,staticClass:"col-md-3 col-6 pb-5"},[_c('div',{staticClass:"slide-box"},[_c('div',{staticClass:"product-box"},[_c('router-link',{attrs:{"to":{
              name: 'detail',
              params: {
                pro_id: product.id_product,
                pro_url_key: product.url_key,
              },
              query: {
                store: _vm.$route.query.store,
                id: product.id_product,
              },
            }}},[_c('img',{staticClass:"new_product_image",attrs:{"src":product.image,"alt":""}})]),_c('div',{staticClass:"viewDetails"},[_c('router-link',{attrs:{"to":{
              name: 'detail',
              params: {
                pro_id: product.id_product,
                pro_url_key: product.url_key,
              },
              query: {
                store: _vm.$route.query.store,
                id: product.id_product,
              },
            }}},[_vm._v("\n            View Detail\n            ")])],1)],1),_c('p',[_vm._v("\n          "+_vm._s(product.name)+"\n        ")]),_c('div',{staticClass:"price"},[_c('p',[_vm._v(" "+_vm._s(_vm._f("formatMoney")(product.selling_price)))])])])])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }